// extracted by mini-css-extract-plugin
module.exports = {"componentWrapper":"Panel_componentWrapper__T6TUw","spinnerContainer":"Panel_spinnerContainer__v9XlG"};